import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
export const PanelItemHeader = ({ id, children, backgroundColor }) => {
    return (_jsx(Typography, { id: id, component: 'div', css: css `
        background-color: ${backgroundColor};
        padding-left: 20px;
        font-weight: bold;
      `, variant: 'subtitle2', children: children }));
};
